export enum ImcCathegoryEnum
{
    underweight = 1,
    normalWeight = 2,
    overweight = 3,
    obesity = 4,
}